import { useRef } from "react";
import MonacoEditor, { Monaco } from "@monaco-editor/react";
import { Box, Stack } from "@mui/material";
import useConfiguratorContext from "datasets/pages/settings/contexts/configurator";
import useDefaultConfig from "datasets/pages/settings/hooks/useDefaultConfig";
import Loading from "~/components/Loading";

const SystemPromptEditor = () => {
  const { data: defaultConfig } = useDefaultConfig();
  const { config: currentConfig, setSystemPrompt } = useConfiguratorContext();
  const monacoRef = useRef<Monaco | null>(null);

  return (
    <Stack gap={2} sx={{ py: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          flexGrow: 1,
          border: "1px solid #E0E0E7",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <MonacoEditor
          height="300px"
          language="plaintext"
          theme="vs-dark"
          loading={<Loading />}
          value={
            currentConfig?.content?.llm_few_shot_examples ??
            defaultConfig?.content?.llm_few_shot_examples
          }
          beforeMount={(monaco) => {
            monacoRef.current = monaco;
          }}
          onChange={(newValue) => setSystemPrompt(newValue || "")}
          options={{
            automaticLayout: true,
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            fixedOverflowWidgets: true,
            lineNumbers: "off",
            padding: { top: 16, bottom: 16 },
            glyphMargin: false,
            folding: false,
            lineDecorationsWidth: 10,
            lineNumbersMinChars: 0,
          }}
        />
      </Box>
    </Stack>
  );
};

export default SystemPromptEditor;
